import { localize } from "client_legacy/ndaw/culture";
import { useEffect } from "react";

export function useWarnBeforeUnload(hasChanges: boolean): void {
	useEffect(
		(): (() => void) | void => {
			if (!hasChanges) {
				return;
			}

			const cancellation = new AbortController();

			window.addEventListener(
				"beforeunload",
				(args): void => {
					args.preventDefault();
					args.returnValue = localize("_YouHaveUnsavedChanges");
				},
				{ signal: cancellation.signal }
			);

			return (): void => cancellation.abort();
		},
		[hasChanges]
	);
}
